<template>
  <div><PageTable /></div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-ftyPurchaseInv',
  components: { PageTable },
}
</script>
